import { Component } from 'react';

import ValueSetFactory from 'binder/components/BinderSetup/ValueSets/ValueSetFactory';
import styles from './FormField.scss';
import lodash from 'lodash';

class FormField extends Component {

    componentDidUpdate(prevProps) {
        if (prevProps.shouldScrollFieldIntoView === false
            && this.props.shouldScrollFieldIntoView === true
            && this.props.fieldToScrollIntoView
            && this.props.fieldToScrollIntoView.groupId === this.props.field.groupId) {

            this.elm.scrollIntoView();
        }
    }

    _getLabel() {
        return this.props.field.getLabel(this.props.descriptor);
    }

    _getInstructionalText() {
        return this.props.field.getInstructionalText(this.props.descriptor);
    }

    render() {
        const {
            field,
            validationErrors,
            onChange
        } = this.props;

        if (field && field.selectedValues) {
            field.selectedValues = field.selectedValues.filter((value) => !lodash.isEmpty(value));
        }

        return (
            <div className={styles.formField} ref={elm => this.elm = elm} data-cy="binderSetup">
                <div className={styles.header}>
                    <label className={styles.label}>
                        {this._getLabel()}
                    </label>
                    <span className={styles.instructionalText}>
                        {this._getInstructionalText()}
                    </span>
                </div>
                <div className={styles.field}>
                    <ValueSetFactory
                        dataType={field.dataType}
                        valueSetName={field.valueSetName}
                        validationErrors={validationErrors}
                        availableValues={field.availableValues}
                        dataSourceId={field.dataSourceId}
                        value={field[field.dataHandlerProperty]}
                        groupId={field.groupId}
                        changeHandler={onChange} />
                </div>
            </div>
        );
    }
}

export default FormField;
